import { render } from "./WebsiteHome.vue?vue&type=template&id=22055698&scoped=true"
import script from "./WebsiteHome.vue?vue&type=script&lang=js"
export * from "./WebsiteHome.vue?vue&type=script&lang=js"

import "./WebsiteHome.vue?vue&type=style&index=0&id=22055698&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22055698"]])

export default __exports__